<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {}
</script>

<style>
    html {
        position: relative;
        min-height: 100%;
    }

    body {
        margin-bottom: 6rem;
        font-family: 'Montserrat', sans-serif;
        /*font-family: 'Bebas Neue', cursive;*/
    }

    .bg-dark-black {
        background-color: #212121 !important;
    }

    .fontbebas {
        font-family: 'Bebas Neue', cursive;
    }
</style>
